
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parceiros-de-entrega",
      function () {
        return require("private-next-pages/parceiros-de-entrega.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parceiros-de-entrega"])
      });
    }
  